<template lang="pug">
	footer.footer.footerContainer
		template(v-if="userPermissions.indexOf('full:credits') > -1")
			p &copy; Brandon Yee
		template(v-if="userPermissions.indexOf('dev:credits') > -1")
			p [[ ADMIN ]]
</template>

<style lang="scss" scoped>
	footer.footer.footerContainer {
		height: 8rem;
		padding-bottom: 3rem;
		font-size: smaller;
	}
</style>

<script>
	import { mapState } from "vuex";

	export default {
		data() {
			return {
				//
			};
		},
		computed: {
			...mapState(["permissions"]),
			userPermissions() {
				return this.permissions ? this.permissions : [];
			}
		}
	};
</script>
